module.exports = __webpack_public_path__ + "img/logo-hu.0c22c7a6.jpg";